import { Box, Button, CircularProgress, ITheme, Typography, useTheme } from '@mui/material'
import React, { useState } from 'react'
import BackButton from '../../common/BackButton'
import { useTranslation } from 'react-i18next'
import UploadDocumentItem from './UploadDocumentItem'
import { useNavigate, useParams } from 'react-router-dom'
import { AUTHENTICATED_ROUTES } from '../../../resources/routes-constants'
import { submitPortfolio } from '../../../store/actions/createPortfolio'
import { useAppDispatch } from '../../../store/reducers/store'

const UploadDocumentsStep: React.FC = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate = useNavigate();
    const theme = useTheme() as ITheme;
    const dispatch = useAppDispatch();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [filesList, setFilesList] = useState<File[]>([]);

    const onFileAdded = (file: File): void => {
        const update = [...filesList];
        update.push(file);
        setFilesList(update);
    }
    
    const onFileRemoved = (index: number): void => {
        const update = [...filesList];
        update.splice(index, 1);
        setFilesList(update);
    }

    const onSubmit = (): void => {
        setIsSubmitting(true);
        dispatch(submitPortfolio()).then(() => {
        navigate(AUTHENTICATED_ROUTES.PORTFOLIO_SUBMITTED_ROUTE.replace(":id", id as string));
        });
    }

    const onCancel = (): void => {
        navigate(-1);
    }

    return <Box display={"flex"} flexDirection={"column"} width={"1400px"} gap={"24px"} paddingBottom={"50px"}>
        <Box display={"flex"} alignItems={"center"} gap={"24px"}>
            <BackButton disabled={isSubmitting} />
            <Typography fontSize={"24px"} fontWeight={"500"} lineHeight={"29.26px"}>{t('CreatePortfolioUploadYourDocuments')}</Typography>
        </Box>
        <Box display={"flex"} gap={"49px"} flexWrap={"wrap"}>
            {filesList.map((f, index) => <UploadDocumentItem key={`upload-document-${f.name}`} index={index} onFileAdded={onFileAdded} onCleared={() => onFileRemoved(index)} file={f} />)}
            <UploadDocumentItem key={"upload-new-file"} index={filesList.length} onFileAdded={onFileAdded} onCleared={() => onFileRemoved(0)} />
        </Box>
        <Box display={"flex"} width={"100%"} justifyContent={"flex-end"} gap={"16px"}>
            <Button variant='contained' disabled={isSubmitting} onClick={onSubmit}>{t('CreatePortfolioButtonSubmit')}
            {isSubmitting && (<CircularProgress
                    size={24}
                    sx={{
                        color: theme.palette.primary.dark,
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        marginTop: '-12px',
                        marginLeft: '-12px',
                    }}
                />)}
            </Button>
            <Button variant='outlined' disabled={isSubmitting} onClick={onCancel}>{t('CreatePortfolioButtonCancel')}</Button>
        </Box>
    </Box>
}

export default UploadDocumentsStep